// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"2f437816","80":"b000a0e8","95":"ee6e3cfe","952":"cf235397"}[chunkId] + ".chunk.css";
};